import { useEffect, useState } from "react";

const getMatch = () =>
  typeof window !== "undefined" && window.matchMedia
    ? window.matchMedia("(prefers-reduced-motion: reduce)").matches
    : false;

export default function usePrefersReducedMotion() {
  const [prefersReduced, setPrefersReduced] = useState(getMatch);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setPrefersReduced(mq.matches);
    const listener = (e) => setPrefersReduced(e.matches);
    mq.addEventListener("change", listener);
    return () => mq.removeEventListener("change", listener);
  }, []);

  return prefersReduced;
}
